var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.98 12.5a7.79 7.79 0 0 1 6.79 3.97 7.11 7.11 0 0 0-4.3 5.933h-.41c-2.632 0-4.765 2.124-4.765 4.744 0 1.256.49 2.398 1.289 3.246H6.198A4.698 4.698 0 0 1 5.983 21l.215-.005h1.911l.116-1.374A7.785 7.785 0 0 1 15.98 12.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.58 17.398a5.64 5.64 0 0 1 5.318 3.739l.416 1.17 1.228-.19q.324-.051.656-.051c2.314 0 4.188 1.865 4.188 4.163s-1.874 4.164-4.188 4.164H18.06a3.255 3.255 0 0 1-3.266-3.246 3.255 3.255 0 0 1 3.266-3.245h1.787l.116-1.373c.244-2.889 2.681-5.131 5.618-5.131"
}))));
export { Svg3 as ReactComponent };